import React from "react";
import moment from "moment";
import { Table,Typography } from "antd";
const{Text}=Typography;

const WhatsTable = (props) => {
  const { modifyAccess } = props;
  const column = [
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
    },
    {
      title: "Sub Module",
      dataIndex: "submodule",
      key: "submodule",
    },
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Created On",
      dataIndex: "createdAt",
      key: "createdOn",
      render: (text) => (
        <span>{moment(new Date(text)).format("DD/MM/YYYY")} </span>
      ),
    },



  ];

  return (
    <>
      <Table
        style={{ cursor: "pointer" }}
        dataSource={props.data}
        loading={props.spinning}
        pagination={props.pagination}
        rowKey={(record) => record.id}
        onRow={(record) => ({
          onClick: () => props.openData(record.id, false),
        })}
        columns={column}
      />
    </>
  );
};

export default WhatsTable;
